 // Whole Component Tejashwini
 import Layout from "./layout";
import { Button, Box } from "@mui/material";
import { useNavigate } from 'react-router-dom';// Page linking using this 

const InventoryManagementDashboard  = () => {
    const navigate = useNavigate();// Page linking using this 


    return(
        <>
        <Layout/>
        {/* <h1 className="table_title" style={{marginTop: '9%' }}> Inventory Management</h1> */}
        <h1 className="title">Inventory Management </h1>
        <Box
                sx={{display: 'flex',justifyContent: 'center',alignItems: 'center',height: '50vh', gap: '8em', }}
            >
                <Button 
                    variant="contained" onClick={() => {navigate('/erp-stock') }}
                    sx={{backgroundColor: '#0A64A2', color: '#fff',left:'2em', borderRadius:'0.4em' ,marginRight: '2em',padding: '40px 90px',fontSize: '14px',fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                    Stock
                </Button> 
                
                <Button
                    variant="contained" onClick={() => {navigate('/erp-product') }} // Page linking using this 
                    sx={{backgroundColor: '#0A64A2',color: '#fff',padding: '40px 50px',fontSize: '14px',borderRadius:'0.4em' ,fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                    Create Products
                </Button>

                <Button
                    variant="contained" onClick={() => {navigate('/erp-kits') }}
                    sx={{backgroundColor: '#0A64A2',color: '#fff',padding: '40px 80px',fontSize: '14px',fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                    Create Kits
                </Button>
            </Box>

        </>
    )
}

export default InventoryManagementDashboard;  
